export default "__VITE_ASSET__DaRLO4qi__"